import initialState from './CategoryInitialState';
import reducers from './CategoryReducer';

export default {
  initialState,
  reducers,
};
